/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormRecordDecimalFieldComponent } from '../../admin/form/form-record/fields/decimal/form-record-decimal-field.component';
/* eslint-enable */

export class FormRecordDecimalFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordDecimalFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
